import { Card, Skeleton } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate, useOutletContext } from 'react-router';
import { Timeline } from '../../../components/Timeline';
import { useLanguage } from '../../../contexts/language';
import { DAYJS_VISUALIZATION_DATE_FORMAT } from '../../../utils/date';
import { InvoiceTemplateSubPageContext } from './types';
import { useEffect } from 'react';
import { PANEL_CARD_INNER_SPACING_CLASSNAME } from '../../../components/AdminTemplates';

const InvoiceRejectionNotesPage = () => {
  const { invoiceId, rejectionNotesManagement } =
    useOutletContext<InvoiceTemplateSubPageContext>();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const { rejectionNotes, isLoading: isLoadingNotes } =
    rejectionNotesManagement;

  useEffect(() => {
    /* There is scenario for redirection:
    1) rejection notes have finished loading but there are none
    */
    if (!isLoadingNotes && !rejectionNotes.length) {
      void navigate(
        invoiceId ? `/admin/invoices/${invoiceId}` : '/admin/invoices',
      );
    }
  }, [navigate, isLoadingNotes, rejectionNotes, invoiceId]);

  return (
    <Card className={PANEL_CARD_INNER_SPACING_CLASSNAME}>
      {isLoadingNotes ? (
        <Timeline<number>
          key="skeleton"
          items={[1, 2, 3]}
          getItemKey={id => id}
          renderItemContent={() => <Skeleton variant="rounded" />}
        />
      ) : (
        <Timeline
          key="notes"
          items={rejectionNotes}
          getItemKey={({ id }) => id}
          renderItemHeader={({ type }) => t(`note-types.${type}`)}
          renderItemContent={({ creationDate, note }) => (
            <div>
              <div className="font-medium opacity-80 text-xs mb-4">
                {dayjs(creationDate).format(DAYJS_VISUALIZATION_DATE_FORMAT)}
              </div>
              <section className="text-sm opacity-80">
                {note.split('\n').map((text, index) => (
                  <p key={index} className="mb-2">
                    {text}
                  </p>
                ))}
              </section>
            </div>
          )}
        />
      )}
    </Card>
  );
};

export default InvoiceRejectionNotesPage;
